import React, { useState } from "react";
import Service_image from "../assets/images/services.webp";
import ServiceCarousel from "../components/ServiceCarousel";
import IpCarousel from "../components/IpCarousel";
import EnquiryModal from "../components/EnquiryModal";

const ServicesPage = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {/* Hero */}
      <section
        style={{
          position: "relative",
          height: 520,
          backgroundImage: `url(${Service_image})`,
          backgroundSize: "cover",
          backgroundPosition: "top center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.50)" }} />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="hero-info-card">
            <p
              className="text-uppercase fw-semibold mb-2"
              style={{ fontSize: "0.75rem", letterSpacing: "0.1em", color: "#009EDC" }}
            >
              What we offer
            </p>
            <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(2.1rem, 4vw, 3.2rem)", lineHeight: 1.15, color: "#0a1a3a" }}>
              Solutions
            </h1>
            <p className="mb-0" style={{ color: "#4B5563", lineHeight: 1.7 }}>
              From cybersecurity to cloud infrastructure, we design, deploy and
              manage technology that keeps your business secure, connected and ahead.
            </p>
          </div>
        </div>
      </section>

      {/* Services grid — white background */}
      <div style={{ background: "#fff" }}>
        <ServiceCarousel />
      </div>

      {/* Products grid — light grey background */}
      <div style={{ background: "#f8fafc" }}>
        <IpCarousel />
      </div>

      {/* CTA section */}
      <section style={{ background: "#0a1a3a", padding: "88px 0" }}>
        <div className="container text-center">
          <p
            className="text-uppercase fw-semibold mb-3"
            style={{ fontSize: "0.75rem", letterSpacing: "0.14em", color: "#009EDC" }}
          >
            Get in touch
          </p>
          <h2
            className="fw-bold mb-3"
            style={{ color: "#fff", fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
          >
            Ready to transform your business?
          </h2>
          <p style={{
            color: "rgba(255,255,255,0.6)",
            maxWidth: 520,
            margin: "0 auto 40px",
            lineHeight: 1.75,
          }}>
            Our team will help you find the right solution for your specific
            needs.<br />
            No jargon, no pressure, just results.
          </p>
          <button
            className="btn btn-lg px-5 fw-semibold"
            style={{ backgroundColor: "#009EDC", color: "#fff", borderRadius: 8 }}
            onClick={() => setModalOpen(true)}
          >
            Start a conversation
          </button>
        </div>
      </section>

      <EnquiryModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default ServicesPage;
